import _ from 'lodash';
import MediaQuery from '../../utils/MediaQuery';
import { INIT_ROOT } from '../actionTypes';

import {
  getQueryStringValue,
  removeQueryStringFromUrl,
  hasQueryStringParam,
} from '../../common/routing/queryStringHelpers';
import {
  getByModelAndKey,
  removeExpiredSavedBuilds,
  getSavedBuildCount,
} from '../../resources/localStorage/localStorage.service';
import { getPostalCode } from '../../factories/initializePostalCode/initializePostalCode.factory';
import { initialize as initializeAnalytics } from '../../factories/analytics/analytics.service';
import getDeviceType from '../../utils/getDeviceType';

export const initRoot = () => {
  const appResources = window.appResources;
  const uiPath = window.UI_PATH;
  const contextPath = window.CONTEXT_PATH;
  const version = window.VERSION;
  const {
    brand,
    country,
    bodyStyle,
    carline,
    language,
    year,
    region,
    urls,
  } = appResources;

  const location = window.location;

  // postalCode -> non shopper link (camel case)
  // postalcode -> shopper param (lower case)
  // non shopper overwrites any postal codes, shopper will be retained throughout the app
  // and be overwritten by akamai or byo zipcodes and updated accordingly
  // Logic for postalcode and other shopper params at useShopperParams.js and addShopperParams.js
  const postalCode = getPostalCode(
    country,
    brand,
    getQueryStringValue(location.search, 'postalCode'),
    getQueryStringValue(location.search, 'postalcode'),
    urls.zipCodeUrl
  );

  if (hasQueryStringParam(location.search, 'postalCode')) {
    const urlWithPostalCodeRemoved = removeQueryStringFromUrl(
      location,
      'postalCode'
    );

    history.replaceState(
      { path: urlWithPostalCodeRemoved },
      null,
      urlWithPostalCodeRemoved
    );
  }

  const params = {
    bodystyle: bodyStyle,
    brand: brand,
    carline,
    country: country,
    lang: language,
    modelyear: year,
    region,
    postalCode: _.get(postalCode, 'value'),
    codeType: _.get(postalCode, 'codeType'),
  };

  const localConfig = getByModelAndKey(appResources, 'config');

  removeExpiredSavedBuilds(brand, country);
  initializeAnalytics(_.get(postalCode, 'value'));

  const checkForSelectionState = () => {
    if (
      hasQueryStringParam(location.search, 'styleId') &&
      !hasQueryStringParam(location.search, 'ss')
    ) {
      return false;
    }
    return _.get(localConfig, 'isSelectionRevealed', false);
  };

  const checkForBodySelection = () => {
    if (
      hasQueryStringParam(location.search, 'styleId') &&
      !hasQueryStringParam(location.search, 'ss')
    ) {
      return true;
    }
    return _.get(localConfig, 'isBodyTypeRevealed', false);
  };

  return {
    type: INIT_ROOT,
    payload: {
      appResources,
      params,
      wasOptionToggled: _.get(localConfig, 'toggled', false),
      wasTrimOptionToggled: _.get(localConfig, 'toggledTrim', false),
      isDefaultPostalCode: _.get(postalCode, 'isDefault'),
      deviceType: getDeviceType(),
      uiPath,
      contextPath,
      version,
      breakpoint: MediaQuery.current,
      isSelectionRevealed: checkForSelectionState(),
      isBodyTypeRevealed: checkForBodySelection(),
      savedBuildCount: getSavedBuildCount(brand, country),
      isLegalDisclosureOpened: false,
    },
  };
};
